import { render } from "./FileUploads.vue?vue&type=template&id=39cb239a&scoped=true"
import script from "./FileUploads.vue?vue&type=script&lang=js"
export * from "./FileUploads.vue?vue&type=script&lang=js"

import "./FileUploads.vue?vue&type=style&index=0&id=39cb239a&scoped=true&lang=css"

import exportComponent from "/Users/bobbarnard/Documents/sources/bungalow7-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39cb239a"]])

export default __exports__